<template>
  <div class="page-container">
    <div class="header">
      <div class="title">代付记录</div>
    </div>
    <div class="search-form">
      <el-form inline class="inline-form" label-width="120px">
        <el-form-item label="创建时间" size="small">
          <el-date-picker
            v-model="dateTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            size="small"
          />
        </el-form-item>
        <el-form-item label="业务代付订单号" size="small">
          <el-input v-model="searchForm.busId" clearable placeholder="请输入业务代付订单号" />
        </el-form-item>
        <el-form-item label="审核状态" size="small">
          <el-select v-model="searchForm.auditStatus" clearable>
            <el-option v-for="([value, label]) in Object.entries(auditStatusOptions)" :value="value" :label="label" :key="value" />
          </el-select>
        </el-form-item>
        <el-form-item label="出账状态" size="small">
          <el-select v-model="searchForm.transStatus" clearable>
            <el-option v-for="([value, label]) in Object.entries(transStatusOptions)" :value="value" :label="label" :key="value" />
          </el-select>
        </el-form-item>
        <el-form-item size="small">
          <el-button type="primary" @click="handleFormSearch" class="bs-btn" :loading="table.loading">查询</el-button>
          <el-button type="primary" @click="handleFormReset" class="bs-btn2">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="createTime" label="创建时间" align="center" min-width="200px"/>
        <el-table-column prop="busId" label="业务代付订单号" align="center" min-width="130px"/>
        <el-table-column prop="merchantId" label="商户编号" align="center" min-width="130px"/>
        <el-table-column prop="merchantName" label="商户名称" align="center" min-width="200px"/>
        <el-table-column prop="amount" label="申请代付金额" align="center" min-width="130px" >
          <template slot-scope="{row}">{{ row.amount / 100 }}</template>
        </el-table-column>
        <el-table-column prop="bankAccountName" label="收款方名称" align="center" min-width="130px"/>
        <el-table-column prop="bankAccountNo" label="收款方账号" align="center" min-width="200px"/>
        <el-table-column prop="bankBranchName" label="收款方开户行" align="center" min-width="200px"/>
        <el-table-column prop="applyId" label="关联的业务充值订单号" align="center" min-width="200px"/>
        <el-table-column prop="auditStatus" label="审核状态" align="center" min-width="130px">
          <template slot-scope="{row}">{{ auditStatusOptions[row.auditStatus] || '' }}</template>
        </el-table-column>
        <el-table-column prop="transStatus" label="出账状态" align="center" min-width="130px">
          <template slot-scope="{row}">{{ transStatusOptions[row.transStatus] || '' }}</template>
        </el-table-column>
        <el-table-column prop="failReason" label="失败原因" align="center" min-width="200px"/>
        <el-table-column prop="billId" label="打款单号" align="center" min-width="200px"/>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
  </div>
</template>
<script>
import { queryPayRecordList } from "../../../api/cloud-manage";

export default {
  name: "payment-record",
  data() {
    return {
      dateTimeRange: null,
      searchForm: {
        busId: '',
        transStatus: '',
        auditStatus: '',
      },
      transStatusOptions: {
        0: '未出账',
        1: '出账成功',
        2: '出账失败',
      },
      auditStatusOptions: {
        0: '待初审',
        1: '初审驳回',
        2: '待复核',
        3: '复核通过',
        4: '复核驳回',
      },
      table: {
        data: [],
        loading: false,
        totalCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.handleFormSearch();
  },
  methods: {
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.searchForm = {
        merchantId: '',
        businessNo: '',
        status: '',
      };
      this.dateTimeRange = null;
      this.handleFormSearch();
    },
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    queryTableData() {
      const [startTime, endTime] = this.dateTimeRange || [];
      const { pageNo, pageSize } = this.table;
      const params = {
        startTime,
        endTime,
        ...this.searchForm,
        pageNo,
        pageSize,
      };
      this.table.loading = true;
      queryPayRecordList(params).then(({ data: { code, data, msg } }) => {
        if (code === '0') {
          this.table.data = data.list;
          this.table.totalCount = data.totalCount;
        } else {
          this.$message.warning(msg);
          this.table.data = [];
          this.table.totalCount = 0;
        }
      }).finally(() => {
        this.table.loading = false;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;
  }

  .table-container {
    padding: 40px 50px;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>
